import GraniteError from 'granite-admin/utils/granite-error';
import { getPermissionsAndSideMenuItems } from 'granite-admin/accounts/gateways/sidebar-api';
import { resetAuthToken, resetSsoLogin } from 'granite-admin/utils/auth-singleton';

/**
 * DashboardLayout Page- implimentation of fetchSidemenuItems
 * @returns {object} response from gateway method
 */
async function loadMenuItemsAndPermissions() {
  try {
    const sidemenuItems = await getPermissionsAndSideMenuItems();
    let MenuItems = [];
    sidemenuItems.forEach(element => {
      if (element.parentId === null && element.isActive) {
        let children = sidemenuItems.filter(item => item.parentId && item.parentId === element.pk);
        if (children.length) element.children = [...children];
        let index = MenuItems.findIndex(item => item.group === element.group);
        if (index !== -1) {
          MenuItems[index].children.push(element);
        } else {
          MenuItems.push({
            group: element.group,
            children: [element]
          });
        }
      }
    });
    return MenuItems;
  } catch (error) {
    let errorMessage = JSON.stringify(error);
    if (error.response) errorMessage = error.response.data.message;
    if (error.message) errorMessage = error.message;
    throw new GraniteError(errorMessage);
  }
}

/**
 * Dashboard-related Pages- removes auth token from local storage
 */
function removeAuthToken() {
  resetAuthToken();
  resetSsoLogin();
}
export { loadMenuItemsAndPermissions, removeAuthToken };